// Hauptordner des Aktenschranks (Spec 2026-07-06) und ihre Farben (Handoff Dokumente §4).

export type HauptordnerKey = '00' | '01' | '02' | '03' | '04' | '05' | '06' | '99';
export const HAUPTORDNER: readonly HauptordnerKey[] = ['00', '01', '02', '03', '04', '05', '06', '99'];

/** Farbe (Punkt, Icon, Balken) und weiche Variante je Hauptordner. */
export const ORDNER_FARBE: Record<HauptordnerKey, { fg: string; bg: string }> = {
  '00': { fg: 'var(--acc)', bg: 'var(--acc-soft)' },
  '01': { fg: 'var(--info)', bg: 'var(--info-soft)' },
  '02': { fg: 'var(--ok)', bg: 'var(--ok-soft)' },
  '03': { fg: 'var(--warn)', bg: 'var(--warn-soft)' },
  '04': { fg: '#8a63d2', bg: 'rgba(138,99,210,0.15)' },
  '05': { fg: 'var(--bad)', bg: 'var(--bad-soft)' },
  '06': { fg: '#2f9a90', bg: 'rgba(47,154,144,0.15)' },
  '99': { fg: 'var(--ink3)', bg: 'var(--fill2)' },
};

/** „02 Finanzen/Rechnungen/2026“ → '02'; sonst null (z. B. leerer oder fremder Pfad). */
export function hauptordnerAus(pfad: string | null | undefined): HauptordnerKey | null {
  const m = /^(\d\d) /.exec((pfad ?? '').trim());
  const k = m?.[1];
  return k && (HAUPTORDNER as readonly string[]).includes(k) ? (k as HauptordnerKey) : null;
}
